export default __webpack_public_path__ + "static/media/sld_tshirt.1af8b61f.png";